



































































import { Prop, Vue, Component } from "vue-property-decorator";

import ModalMain from "@/common/components/organisms/ModalMain.vue";
import ButtonMain from "@/common/components/atoms/ButtonMain.vue";
import IconUserImage from "@/common/components/icons/IconUserImage.vue";
import SmallText from "@/common/components/atoms/SmallText.vue";

import modalState from "@/common/store/modules/modalState";
import globals from "@/general/store/modules/globals";
import commons from "@/common/store/modules/commons";

@Component({
  components: {
    ModalMain,
    ButtonMain,
    SmallText,
    IconUserImage
  }
})
export default class ModalSelectSendUser extends Vue {
  @Prop({ type: Object, required: true }) user!: any;
  @Prop({ type: Object, required: true }) transaction!: any;
  @Prop({ type: String, default: "" }) reason!: string;

  get colorCode() {
    return commons.colorCode;
  }

  get profileIconSize() {
    const isSpScreenWidth = globals.isSpScreenWidth;
    return isSpScreenWidth ? 80 : 144;
  }

  get title() {
    return this.transaction?.transaction_details?.title;
  }

  get message() {
    return this.transaction?.transaction_details?.message;
  }

  // DX_IC-815 【バグ】一般画面_サンクスポイントの否認理由に表示されている文言が期待値と異なる
  get approverComment() {
    return this.transaction?.transaction_details?.approver_comment;
  }

  closeModal() {
    modalState.changeModal("");
  }
}
